import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'

import {
    getDivisa
} from '../../utils/helpers'


import AttachedAditionalsBox from '../Documentos/AttachedAditionalsBox'

class Adiciones extends Component {
	render() {

        const { documento, divisas } = this.props
        if (!documento) return null

        const moneda = documento.getIn(['cotizacion', 'moneda']);
        const divisa = getDivisa(divisas, moneda) 


		return (
            <Fragment>
                <AttachedAditionalsBox
                    adiciones={ documento.get('adiciones') }
                    divisa={divisa}
                />
            </Fragment>
		)
	}
}

function mapStateToProps(state) {
    return {
        documento: state.documentos.getIn(['modalSummary', 'data']),
        divisas: state.common.getIn(['parametros', 'DIVISAS'])
    }
}

function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Adiciones)


// WEBPACK FOOTER //
// ./src/components/Documentos/Adiciones.jsx